/**
 * Constants specific to the BottomNavBar component.
 */
export const bottomTabBarHeight = 80;
